var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path !== '/admin')?_c('HeaderComponent'):_vm._e(),_c('main',{class:{ 'main-container': _vm.$route.path !== '/admin', 'admin-main-container': _vm.$route.path === '/admin' },attrs:{"id":"main"}},[_c('router-view')],1),(_vm.$route.path !== '/admin')?_c('FooterComponent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }